import { useState } from 'react';

const WHATSAPP_NUMBER = '19044019383';
const WHATSAPP_MESSAGE = encodeURIComponent(
  'Olá! / Hi! I found VM Construction online and I\'d like a FREE estimate.\n\n' +
  'Project type: ___\n' +
  'Location (city): ___\n' +
  'Approx. sq ft: ___\n\n' +
  'I can also send photos if helpful!'
);
const WHATSAPP_URL = `https://wa.me/${WHATSAPP_NUMBER}?text=${WHATSAPP_MESSAGE}`;

export default function WhatsAppButton() {
  const [hovered, setHovered] = useState(false);

  return (
    <div className="fixed bottom-6 right-6 z-[55] hidden md:flex items-center justify-end gap-3">
      {/* Tooltip */}
      <div
        className={`transition-all duration-300 ${
          hovered ? 'opacity-100 translate-x-0' : 'opacity-0 translate-x-3 pointer-events-none'
        }`}
      >
        <div className="relative bg-[#0d0d0d] border border-white/10 text-white px-4 py-3 rounded-xl whitespace-nowrap">
          <p className="text-sm font-bold leading-tight">Chat on WhatsApp</p>
          <p className="text-white/50 text-xs mt-0.5">Respondemos em minutos · We reply fast</p>
        </div>
      </div>

      {/* Button */}
      <a
        href={WHATSAPP_URL}
        target="_blank"
        rel="nofollow noopener noreferrer"
        aria-label="Chat on WhatsApp — VM Construction"
        onMouseEnter={() => setHovered(true)}
        onMouseLeave={() => setHovered(false)}
        className="relative w-14 h-14 flex items-center justify-center rounded-full bg-[#25D366] hover:bg-[#1ebe5d] cursor-pointer transition-all duration-300 hover:scale-110"
        style={{ boxShadow: '0 4px 24px rgba(37,211,102,0.45)' }}
      >
        {/* Pulse ring */}
        <span className="absolute inset-0 rounded-full bg-[#25D366] animate-ping opacity-25" />
        <i className="ri-whatsapp-line text-white text-2xl relative z-10" />
      </a>
    </div>
  );
}
